import { QuestionType } from 'mobx-store/storeInterfaces/facilityFormInterface';
import { QuestionPreviewType } from 'mobx-store/storeInterfaces/surveyInterface';
import {
  BaseFormViewModel,
} from '../types';
import {
  FacilityDTO,
} from './staticTextDTO';

export class FacilityFormViewModel extends BaseFormViewModel<FacilityDTO> {
  key: string;

  app: string;

  category: string;

  description: string;

  languageCode: string;

  value: string;

  constructor(dto: FacilityDTO) {
    super();
    Object.assign(this, dto);
  }

  toDTO() {
    return this;;
  }
}
